import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 填寫基本資料
 */
const FillBasicDataPostBack = [
    'POST',
    RouteUrlList.API_FillBasicPostBack.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: ''
    }
];
export default FillBasicDataPostBack;
